// extracted by mini-css-extract-plugin
var _1 = "DurationField-moduleinput__OMFEg";
export { _1 as "input" }
